export const API_ERRO = {
  VALOR_INDISPONIVEL: 'VALUE_NOT_UNIQUE',
  PARAMETRO_INVALIDO: 'INVALID_PARAMETER',
  TOKEN_EXPIRADO: 'EXPIRED_TOKEN',
  ERRO_SERVIDOR: 'INTERNAL_SERVER_ERROR',
};
